(() => {
  const ready = new WeakSet();
  function initGallery(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const images = Array.from(root.querySelectorAll('[data-sb-image]'));
    if (!images.length) return;
    const thumbnails = Array.from(root.querySelectorAll('[data-sb-thumbnail]'));
    const zoomThumbnails = Array.from(root.querySelectorAll('[data-sb-zoom-thumbnail]'));
    const dialog = root.querySelector('dialog');
    const zoom = dialog.querySelector('.sb-metapal-zoom-image');
    const counter = dialog.querySelector('[data-sb-image-count]');
    let current = 0;
    function select(index) {
      current = (index + images.length) % images.length;
      images.forEach((image, i) => { image.hidden = i !== current; });
      thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      zoomThumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
      if (dialog.open) {
        zoom.removeAttribute('srcset');
        zoom.removeAttribute('sizes');
        zoom.src = images[current].dataset.full;
        zoom.alt = images[current].querySelector('img').alt;
        counter.textContent = `${current + 1} / ${images.length}`;
        zoomThumbnails[current].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }
    images.forEach((image, index) => image.addEventListener('click', () => {
      dialog.showModal();
      select(index);
    }));
    thumbnails.forEach((button, index) => button.addEventListener('click', () => select(index)));
    zoomThumbnails.forEach((button, index) => button.addEventListener('click', () => select(index)));
    root.querySelectorAll('[data-sb-prev], [data-sb-zoom-prev]').forEach(button => button.addEventListener('click', () => select(current - 1)));
    root.querySelectorAll('[data-sb-next], [data-sb-zoom-next]').forEach(button => button.addEventListener('click', () => select(current + 1)));
    root.querySelector('[data-sb-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        select(current + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
  }
  function initResources(root) {
    if (ready.has(root)) return;
    ready.add(root);
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    function select(index, focus) {
      tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        panels[i].hidden = i !== index;
        if (i !== index) panels[i].querySelectorAll('iframe').forEach(frame => {
          const origin = new URL(frame.src).origin;
          frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), origin);
          frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
        });
      });
      if (focus) tabs[index].focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, false));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); select(next, true); }
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-sb-native-product]').forEach(initGallery);
    document.querySelectorAll('[data-sb-resources]').forEach(initResources);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
